import { MONITOR_COLORS } from "../config/functions";
import { CounterIcon, LockerIcon, MachineIcon } from "../../../../common/Icons";
import React from "react";
import { Box, Typography } from "@mui/material";

const typeConfig = {
    machine: {
        label: 'Máquinas',
        subLabel: 'Ativas',
        backgroundColor: MONITOR_COLORS.background.machine,
        icon: MachineIcon,
        iconColor: MONITOR_COLORS.equipment.machine
    },
    counter: {
        label: 'Balcões',
        subLabel: 'Ativos',
        backgroundColor: MONITOR_COLORS.background.counter,
        icon: CounterIcon,
        iconColor: MONITOR_COLORS.equipment.counter
    },
    locker: {
        label: 'Armários',
        subLabel: 'Ativos',
        backgroundColor: MONITOR_COLORS.background.locker,
        icon: LockerIcon,
        iconColor: MONITOR_COLORS.equipment.locker
    }
};

export function MonitorCard({ type, total, active, offline }) {
    const config = typeConfig[type];
    const Icon = config.icon;

    const statusColor = offline > 0
        ? MONITOR_COLORS.status.error.secondary
        : MONITOR_COLORS.status.success;

    return (
        <Box sx={{
            backgroundColor: MONITOR_COLORS.secondary,
            border: '1px solid ' + MONITOR_COLORS.tertiary,
            borderRadius: 3,
            p: { xs: 2, xl: 3 },
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1.5, xl: 2.5 },
            minWidth: { xs: 160, md: 190, xl: 230, '2xl': 260 },
            height: '100%',
            marginRight: '1vw'
        }}>
            <Box sx={{
                width: { xs: 44, xl: 56 },
                height: { xs: 44, xl: 56 },
                borderRadius: 2,
                backgroundColor: config.backgroundColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginRight: '1vw'
            }}>
                <Icon sx={{ fontSize: { xs: 24, xl: 30 }, color: config.iconColor }} />
            </Box>

            <Box>
                <Typography sx={{
                    fontSize: { xs: '0.75rem', xl: '0.9rem' },
                    color: MONITOR_COLORS.text.secondary,
                    lineHeight: 1.5,
                }}>
                    {config.label}
                </Typography>

                <Typography sx={{
                    fontSize: { xs: '1.6rem', xl: '2rem' },
                    fontWeight: 700,
                    color: MONITOR_COLORS.text.primary,
                    lineHeight: 1.2,
                }}>
                    {active != null && total != null ? `${total}` : '--'}
                </Typography>

                {offline != null && (
                    <Typography sx={{
                        fontSize: { xs: '0.65rem', xl: '0.75rem' },
                        color: statusColor,
                        lineHeight: 1.2,
                    }}>
                        {offline > 0 ? `${offline} offline` : 'Todos online'}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}